"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function User({ color, size = 20 }) {
    return (react_1.default.createElement(react_native_svg_1.default, { viewBox: "0 0 14.02 15.05", width: size, height: size },
        react_1.default.createElement(react_native_svg_1.Path, { d: "M9.36 8.2a4.39 4.39 0 10-4.46-.08A7 7 0 000 14.77v.28h1v-.28a6 6 0 0112.06 0v.28h1a2.46 2.46 0 000-.28 7 7 0 00-4.7-6.57zM3.78 4.39a3.43 3.43 0 113.43 3.4 3.42 3.42 0 01-3.43-3.4z", fill: color })));
}
exports.User = User;
